import React from 'react'
import "./Portfolio.css"
import web_66 from "../../asset/web/66.PNG"
import web_77 from "../../asset/web/77.PNG"
import web_1 from "../../asset/web/1.PNG"
import web_44 from "../../asset/web/44.PNG"
import web_55 from "../../asset/web/55.PNG"
import web_2 from "../../asset/web/2.PNG";
import web_3 from "../../asset/web/3.PNG";
import web_88 from "../../asset/web/88.PNG";
import photo_1 from "../../asset/graph/photo_1.jpg"
import photo_2 from "../../asset/graph/photo_2.jpg"
import photo_3 from "../../asset/graph/photo_3.jpg"
import photo_4 from "../../asset/graph/photo_4.jpg"
import photo_5 from "../../asset/graph/photo_5.jpg"
import habesha from "../../asset/graph/habeshaN.jpg"
import photo_6 from "../../asset/graph/photo_6.PNG"
import brand from "../../asset/graph/brand.PNG"

function Portfolio() {
  return (
      <div className='portfolio' id='Portfolio'>
          <p style={{textAlign:"center",fontWeight:"bold",fontSize:"2rem"}}>Website design </p>
          <div className="row">
              <div className="blur b-locate" style={{background:"orange"}}></div>
              <div className="column">
                <img src={web_1} alt="11" />
                <img src={web_66} alt="66" className='rotate'/>
              </div>
              <div className="column">
                  <img src={web_2} alt="11" />
                  <img src={web_44} alt="77" />
                  <img src={web_55} alt="66" />
              </div>
              <div className="column">
                  <img src={web_3} alt="3" />
                  <img src={web_88} alt="88" className='rotate' />
                  <img src={web_77} alt="77" className='lastI' />
              </div>
          </div>
          <p style={{ textAlign: "center", fontWeight: "bold", fontSize: "2rem",marginTop:"8rem" }}>Graphics design </p>
          <div className="row">
              
              <div className="blur b-locate" style={{ background: "blue" }}></div>
              <div className="column">
                  <img src={brand} alt="bra" />
                  <img src={photo_1} alt="11" />
                  <img src={photo_2} alt="66" className='rotate' />
              </div>
              <div className="column">
                  <img src={photo_3} alt="11" />
                  <img src={photo_4} alt="77" />
              </div>
              <div className="column">
                  <img src={photo_5} alt="3" />
                  <img src={habesha} alt="3" className='rotate' />
                  <img src={photo_6} alt="uru" />
              </div>
          </div>
      </div>
        
                                          
  )
}

export default Portfolio